export default "__VITE_ASSET__BFua9eOj__"